module.exports = __webpack_public_path__ + "static/media/rugrats-bg.7f443c80.png";